import { render, staticRenderFns } from "./RiwayatObatPasien.vue?vue&type=template&id=dd368b06&scoped=true"
import script from "./RiwayatObatPasien.vue?vue&type=script&lang=js"
export * from "./RiwayatObatPasien.vue?vue&type=script&lang=js"
import style0 from "./RiwayatObatPasien.vue?vue&type=style&index=0&id=dd368b06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd368b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd368b06')) {
      api.createRecord('dd368b06', component.options)
    } else {
      api.reload('dd368b06', component.options)
    }
    module.hot.accept("./RiwayatObatPasien.vue?vue&type=template&id=dd368b06&scoped=true", function () {
      api.rerender('dd368b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/riwayat_pasien/RiwayatObatPasien.vue"
export default component.exports